
<q-table
  v-bind="$attrs"
  :data="tableData"
  wrap-cells
  hide-bottom
  :grid="mobile"
  :columns="columns"
  :rows-per-page-options="[0]"
  :pagination="{
    page: 1,
    rowsPerPage: 0, // 0 means all rows
  }"
  flat
  :hide-header="hideHeader"
  class="cmp-domains-result-table ws-table remove-scroll"
  :class="{
    mobile,
    'not-mobile': desktop || tablet,
    'hide-header': hideHeader,
    dark,
  }"
>
  <template v-slot:header="props">
    <q-tr :props="props">
      <q-th key="domain" :props="props" class="col-th-domain">
        {{ $t('domain_checker.domain') }}
      </q-th>

      <q-th key="period" auto-width :props="props" class="col-th-period">
        {{ $t('cart.col.period.title') }}
      </q-th>

      <q-th key="price" :props="props" class="col-th-price text-right">
        {{ $t('domain_checker.price') }}
      </q-th>

      <q-th
        key="action"
        :props="props"
        class="col-th-action text-bold ws-text-dark"
      />
    </q-tr>
  </template>

  <template v-slot:body="props">
    <q-tr class="spacer" />
    <domain-result-item :props="props" :dark="dark" />
    <q-tr
      v-if="isShownBundleForDomain(get(props, 'row.domain.name'))"
      class="spacer"
    />
    <domain-result-item
      v-if="isShownBundleForDomain(get(props, 'row.domain.name'))"
      is-bundle
      :props="props"
      :dark="dark"
    />
  </template>

  <!-- GRID TEMPLATE (MOBILE) -->
  <template v-slot:item="props">
    <domain-result-item mobile :props="props" :dark="dark" />
    <domain-result-item
      v-if="isShownBundleForDomain(get(props, 'row.domain.name'))"
      is-bundle
      :props="props"
      :dark="dark"
      mobile
    />
  </template>
</q-table>
